import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TooltipModalComponent } from '../tooltip-modal/tooltip-modal.component';
import { PopoverController } from '@ionic/angular';
import { CartService } from '../../../modules/cart/service/cart.service';
import { CartComponent } from '../../../modules/cart/cart.component';

@Component({
  selector: 'app-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonComponent {

  @Input() tooltipTitle: string = '';
  @Input() tooltipDescription: string = '';
  @Input() tooltipBtnText: string = '';
  @Input() toggleTitle: string = '';
  @Input() toggleDescription: string = '';
  @Input() cartId: string = '';
  @Input() isEnabled: boolean = false;
  @Output() onToggleState: EventEmitter<any> = new EventEmitter();
  @Input() disabled: boolean = false;
  
  constructor(
    private popoverController: PopoverController,
    private cartService: CartService
  ) {}

  ngOnInit() {}

  toggleState() {
    this.isEnabled = !this.isEnabled;
    const modalObj = {
      cartId: this.cartId
    };
    let self = this;
    if (this.isEnabled) {
      this.cartService.applyPartialPay(modalObj).then((res) => {
        this.onToggleState.emit('PartialPay');
        console.log(res)
      })
    } else {
      this.cartService.removePartialPay(modalObj).then((res) => {
        this.onToggleState.emit('PartialPay');
        console.log(res)
      })
    }
  }

  async showTooltip() {
    event.stopPropagation();
    const popover = await this.popoverController.create({
      component: TooltipModalComponent,
      cssClass: 'tooltip-popover',
      translucent: true,
      showBackdrop: true,
      backdropDismiss: true,
      mode: 'ios',
      componentProps: {
        title: this.tooltipTitle,
        description: this.tooltipDescription,
        btnText: this.tooltipBtnText
      }
    });
    return await popover.present();
  }
}
